// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"d3192d17","142":"9ec33c19","180":"3df109be","327":"acd0485a","425":"e0b46d57","473":"0882bea5","741":"20cbcd1f","787":"493a1a82","845":"27a028f4","883":"9b85f36b","943":"7dd3e24c"}[chunkId] + ".chunk.js";
};